"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = exports.resultMessages = exports.Result = void 0;
const schema_1 = require("../../../schema");
var Result;
(function (Result) {
    Result["ABNORMAL"] = "ABNORMAL";
    Result["NORMAL"] = "NORMAL";
})(Result || (exports.Result = Result = {}));
exports.resultMessages = {
    [Result.ABNORMAL]: {
        id: "htx.screeningProcedures.stoolBlood.result.ABNORMAL",
        defaultMessage: "Igen"
    },
    [Result.NORMAL]: {
        id: "htx.screeningProcedures.stoolBlood.result.NORMAL",
        defaultMessage: "Nem"
    }
};
const result = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(Result.ABNORMAL),
    schema_1.Schema.singleChoiceItem(Result.NORMAL)
])
    .expiration(31104000)
    .interpretation({ vocab: "htx", code: "stool_blood_result" });
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ result })
    .tag({ vocab: "snomed", code: "20135006" })
    .tag({ vocab: "snomed", code: "442516004" })
    .tag({ vocab: "loinc", code: "50196-5" });
